import { Stack } from "@mui/material";

import { TinyIconGenerator } from "@qubit/autoparts";

export function TemperatureZoneHint(props: { temperatureZones: string[] }) {
  const { temperatureZones } = props;
  return temperatureZones.length === 0 ? null : (
    <Stack direction="column" gap={0.5}>
      {temperatureZones.toSorted().map((temperatureZone, i) => (
        <TinyIconGenerator
          tempZone={
            temperatureZone.toLowerCase() as "ambient" | "chilled" | "frozen"
          }
          type="Tote"
          key={`${temperatureZone}-${i}`}
        />
      ))}
    </Stack>
  );
}
